import { mountIslands } from '../islands'
import { mountPlate } from '../plate'

// scroll reveal (DESIGN.md §10 — restrained, respects prefers-reduced-motion via CSS)
const io = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    if (e.isIntersecting) {
      e.target.classList.add('in')
      io.unobserve(e.target)
    }
  })
}, { threshold: 0.12 })
document.querySelectorAll('.rv').forEach((el) => io.observe(el))

// Phone menu (DESIGN.md §9 — the frame's nav row becomes a panel below 900px).
// The panel is nav.site itself, so this only flips a class and the ARIA state.
const header = document.querySelector<HTMLElement>('header.site')
const burger = header?.querySelector<HTMLButtonElement>('.h-burger')
if (header && burger) {
  const setOpen = (open: boolean) => {
    header.classList.toggle('menu-open', open)
    burger.setAttribute('aria-expanded', String(open))
  }
  burger.addEventListener('click', () => setOpen(!header.classList.contains('menu-open')))
  // A link inside the panel navigates, but same-page anchors would leave it open.
  header.querySelectorAll('nav.site a').forEach((a) => a.addEventListener('click', () => setOpen(false)))
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header.classList.contains('menu-open')) {
      setOpen(false)
      burger.focus()
    }
  })
  document.addEventListener('click', (e) => {
    if (header.classList.contains('menu-open') && !header.contains(e.target as Node)) setOpen(false)
  })
  // Rotating past the breakpoint puts nav.site back in the header row; the class
  // would otherwise linger and leave the burger showing a cross.
  matchMedia('(max-width: 900px)').addEventListener('change', (e) => {
    if (!e.matches) setOpen(false)
  })
}

// Which continent the phone diptych is showing. CSS can pin the Bosphorus strip to both
// edges on its own, but not tell the arrow which way the crossing now lies.
const diptych = document.querySelector<HTMLElement>('.diptych')
if (diptych) {
  const syncCrossing = () =>
    diptych.classList.toggle('crossed', diptych.scrollLeft > diptych.clientWidth / 2)
  diptych.addEventListener('scroll', syncCrossing, { passive: true })
  syncCrossing()
}

mountPlate()
mountIslands()
